import { useBlocker, useNavigate, useParams } from 'react-router-dom';
import Button from '../../../../../component/ui/Button';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { createInvoice, updateInvoice } from '../../../../../services/invoices';
import Modal from '../../../../../component/modal/Modal';
import { getRoundedOff, getRoundedOffAmount } from '../../../components/TaxesCalculation';
import { hasPermission } from '../../../../../utils/controller';
import { useSelector } from 'react-redux';

const CreateInvoiceHeader = ({
	error,
	setError,
	tableError,
	setTableError,
	invoice,
	invoiceTable,
	totalAmount,
	totalDiscountAmount,
	totalTaxesAmount,
	calculateAmount,
	additionDiscountAndTax,
}) => {
	const navigate = useNavigate();
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const suburl = localStorage.getItem('suburl');
	const param = useParams();
	const id = param?.id;
	const [loading, setLoading] = useState({
		isLoading: false,
		status: null,
		isSendEmail: false,
	});
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isInvoiceAutoSave, setIsInvoiceAutoSave] = useState(false);

	const checkValidation = (status) => {
		let newError = { ...error };
		let newTableError = [...tableError];
		if (!invoice.customer_id || invoice.customer_id === '' || invoice.customer_id === undefined) {
			newError.customer_id = 'Please select a valid customer from the list.';
		} else {
			delete newError.customer_id;
		}

		if (
			!invoice.invoice_number ||
			invoice.invoice_number === '' ||
			invoice.invoice_number === undefined
		) {
			newError.invoice_number = 'Please enter imvoice numnber in the field';
		} else {
			delete newError.invoice_number;
		}

		if (
			!invoice.date ||
			invoice.date === '' ||
			invoice.date === undefined ||
			(invoice.date !== '' && newError.date)
		) {
			newError.date = newError.date ?? 'Please enter date in the field';
		} else {
			delete newError.date;
		}

		if (
			!invoice.payment_method ||
			invoice.payment_method === '' ||
			invoice.payment_method === undefined
		) {
			newError.payment_method = 'Please select a valid customer from the list.';
		} else {
			delete newError.payment_method;
		}
		if (status === 1) {
			if (invoiceTable.length > 0) {
				let productIndex = Number(invoiceTable.length) - 1;
				if (invoiceTable[productIndex].product_id === '') {
					newTableError = [...newTableError, { index: productIndex, name: 'product_id' }];
				} else {
					delete newError.product_id;
				}
				if (
					invoiceTable[productIndex].batch_no === '' ||
					invoiceTable[productIndex].batch_no === null
				) {
					newTableError = [...newTableError, { index: productIndex, name: 'batch_no' }];
				} else {
					delete newError.batch_no;
				}
				if (
					invoiceTable[productIndex].quantity === '' ||
					invoiceTable[productIndex].quantity === null ||
					Number(invoiceTable[productIndex].quantity) === 0
				) {
					newTableError = [...newTableError, { index: productIndex, name: 'quantity' }];
				} else {
					delete newError.quantity;
				}
			} else {
				newTableError = [...newTableError, { index: 0, name: 'product_id' }];
				newTableError = [...newTableError, { index: 0, name: 'batch_no' }];
				newTableError = [...newTableError, { index: 0, name: 'quantity' }];
			}
		}
		if (Object.keys(newError).length > 0 || newTableError.length > 0) {
			setError(newError);
			setTableError(newTableError);
			return true;
		} else {
			return false;
		}
	};

	const handleSubmitInvoice = async (status, isSendEmail = false) => {
		const isErrorShow = checkValidation(status);
		if (isErrorShow) {
			toast.error('Please fill all mandatory fields before saving');
		} else {
			try {
				let invoice_id = null;
				setLoading((prev) => ({
					...prev,
					isLoading: true,
					status: status,
					isSendEmail: isSendEmail,
				}));
				const body = {
					customer_id: invoice.customer_id,
					doctor_id: invoice.doctor_id,
					invoice_number: invoice.invoice_number,
					date: invoice.date,
					sale_order_id: invoice.sale_order_id,
					remark: invoice.remark,
					payment_method_id: invoice.payment_method,
					due_date: invoice.due_date,
					status: status,
					discount: totalDiscountAmount(),
					adjustment: additionDiscountAndTax.adj ?? 0,
					taxes: totalTaxesAmount(),
					total_amount: getRoundedOffAmount(Number(totalAmount()).toFixed(2)),
					round_off: getRoundedOff(Number(totalAmount()).toFixed(2)),
					sub_total_amount: calculateAmount(),
					products: invoiceTable
						.filter(
							(product) =>
								product.product_id !== '' &&
								product.product_id !== null &&
								product.quantity !== 0 &&
								product.quantity !== null &&
								product.quantity !== '' &&
								product.mrp !== 0 &&
								product.mrp !== null &&
								product.mrp !== '' &&
								product.amount !== 0 &&
								product.amount !== null &&
								product.amount !== '',
						)
						.map((prod) => {
							const { quantity, mrp, expiry_date, batch_no, product_batch_id, amount, ...rest } =
								prod;
							return {
								...rest,
								quantity: Number(quantity),
								mrp: Number(mrp),
								expiry: expiry_date,
								product_batch_id: Number(product_batch_id),
								amount: Number(amount),
							};
						}),
				};
				if (id && !id.includes('id')) {
					await updateInvoice(id, body);
					toast.success('Inovice updated Successfully');
					if (
						isSendEmail &&
						hasPermission('sales.invoices.communications_email', user?.role?.role_permissions)
					) {
						navigate(`/user/${suburl}/invoice-send-emails/${invoice_id}`);
					} else {
						navigate(`/user/${suburl}/invoices`);
					}
				} else {
					let res = await createInvoice(body);
					if (res.success) {
						invoice_id = res.data.invoice?.id;
						toast.success('Invoice Created Successfully');
						if (isSendEmail) {
							setIsLocationBlocker(false);
							setIsInvoiceAutoSave(false);
							setTimeout(() => {
								navigate(`/user/${suburl}/invoice-send-emails/${invoice_id}`);
							}, 300);
						} else {
							setIsLocationBlocker(false);
							setIsInvoiceAutoSave(false);
							setTimeout(() => {
								navigate(`/user/${suburl}/invoices`);
							}, 300);
						}
					} else {
						toast.error(res.message ?? 'something went wrong');
					}
				}
			} catch (error) {
				toast.error(error.message ?? 'something went wrong');
			} finally {
				setLoading((prev) => ({
					...prev,
					isLoading: false,
					status: status,
					isSendEmail: isSendEmail,
				}));
			}
		}
	};
	useBlocker((tx) => {
		if (!id && isLocationBlocker) {
			setIsNextLocation(tx);
			setIsInvoiceAutoSave(true);
			return true;
		}
		return false;
	});

	return (
		<div
			className="product-pg-header add-product"
			style={{ position: 'sticky', top: 0, zIndex: 100 }}
		>
			<p>
				{id ? 'Update ' : 'Create New '}
				Invoice
			</p>
			<div className="add-product-button">
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button="Save"
					loader={loading?.status === 1 && loading.isLoading && !loading.isSendEmail}
					disabled={
						(loading?.status === 1 && loading.isLoading && !loading.isSendEmail) ||
						!hasPermission('sales.invoices.create', user?.role?.role_permissions)
					}
					onClick={() => {
						setIsInvoiceAutoSave(false);
						handleSubmitInvoice(1);
					}}
				/>
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button="Save and Send"
					loader={loading?.status === 1 && loading.isLoading && loading.isSendEmail}
					disabled={
						(loading?.status === 1 && loading.isLoading && loading.isSendEmail) ||
						!hasPermission('sales.invoices.create', user?.role?.role_permissions)
					}
					onClick={() => {
						setIsInvoiceAutoSave(false);
						handleSubmitInvoice(1, true);
					}}
				/>
				<Button
					type="button"
					className="btn-primary mt-0 px-4"
					button="Save as Draft"
					loader={loading?.status === 0 && loading.isLoading}
					disabled={
						(loading?.status === 0 && loading.isLoading) ||
						!hasPermission('sales.invoices.create', user?.role?.role_permissions)
					}
					onClick={() => {
						setIsInvoiceAutoSave(false);
						handleSubmitInvoice(0);
					}}
				/>
				<Button
					type="button"
					className="mt-0 btn-danger add-pro"
					button=""
					close
					onClick={() => navigate(`/user/${suburl}/invoices`)}
				/>
			</div>
			{isInvoiceAutoSave && (
				<Modal
					className="deleteVendorsModal"
					title="Invoice Auto Save"
					isOpen={isInvoiceAutoSave}
					onClose={() => {
						setIsInvoiceAutoSave(false);
					}}
					cancelButton={() => {
						setIsInvoiceAutoSave(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						You have unsaved changes. Do you want to continue without saving?
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Leave Without Saving"
							className="mt-0 px-4 btn-danger relative"
							onClick={() => {
								setIsLocationBlocker(false);
								setIsInvoiceAutoSave(false);
								setTimeout(() => {
									navigate(isNextLocation.nextLocation?.pathname);
								}, 300);
							}}
						/>
						<Button
							type="button"
							button="Save As Draft"
							disabled={!hasPermission('sales.invoices.create', user?.role?.role_permissions)}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsInvoiceAutoSave(false);
								handleSubmitInvoice(0);
							}}
						/>
						<Button
							type="button"
							button="Save and Continue"
							disabled={!hasPermission('sales.invoices.create', user?.role?.role_permissions)}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsInvoiceAutoSave(false);
								handleSubmitInvoice(1);
							}}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
};
export default CreateInvoiceHeader;
